import { render, staticRenderFns } from "./ApiRegionalCreate.vue?vue&type=template&id=ec293598&"
import script from "./ApiRegionalCreate.vue?vue&type=script&lang=js&"
export * from "./ApiRegionalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports